import { Injectable } from '@angular/core';
import { DataListModel } from '../../models/data-list-model';
import { Observable } from 'rxjs';
import { Product } from '../../dto/product';
import { HttpParams, HttpClient } from '@angular/common/http';
import { CrudService } from '../../services';
import {Newsletter} from '../../dto/newsletter';
import {NewsletterDetail} from '../../dto/newsletterDetail';
import {NewsletterSendTest} from '../../dto/newsletter-send-test';

@Injectable({
  providedIn: 'root'
})

export class NewsletterService implements CrudService<Newsletter> {
  readonly apiPath = 'newsletter/';
  public id: number;
  constructor(
    private http: HttpClient,
  ) { }

  get(id: any) {
    return this.http.get(this.apiPath + id) as Observable<Newsletter>;
  }

  getDetails(id: any) {
    return this.http.get(this.apiPath +'details/'+ id) as Observable<NewsletterDetail[]>;
  }


  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string,
    additionalFilterData?: string[],
    enumFilter?: { key: string; value: string }
  ) {
    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString)
      .set('sortField', sortField)
      .set('sortDirection', sortDirection)
      .set('someAdditionalData', someAdditionalData);

    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }
    if (additionalFilterData instanceof Array) {
      additionalFilterData.forEach(element => {
        params = params.append('additionalFilterData', element);
      });
    }
    if (enumFilter) {
      params = params.append('enumFilter', JSON.stringify(enumFilter));
    }


    return this.http.get(this.apiPath, { params }) as Observable<DataListModel<Newsletter>>;
  }


  update( item: Newsletter ) {
    return this.http.put(this.apiPath, item) as Observable<Newsletter>;
  }

  sendTest( item: NewsletterSendTest ) {
    return this.http.post(this.apiPath+'send-test', item) as Observable<Newsletter>;
  }


  add(item: Newsletter): Observable<Newsletter> {
    return this.http.post(this.apiPath, item) as Observable<Newsletter>;
  }

  delete(id: any): Observable<Object> {
    return undefined;
  }

  deleteMany(list: any[]): Observable<Object> {
    return undefined;
  }

  restore(id: any): Observable<Object> {
    return undefined;
  }

  restoreMany(list: any[]): Observable<Object> {
    return undefined;
  }


  copyTemplate(id: number): Observable<Newsletter> {
    return this.http.post(this.apiPath + 'copy', {id}) as Observable<Newsletter>;
  }

  emergencyStop(id: number) {
    return this.http.post(this.apiPath + 'emergency-stop', {id}) as Observable<Newsletter>;
  }

  cancelApproval(id: number) {
    return this.http.post(this.apiPath + 'cancel-approval', {id}) as Observable<Newsletter>;
  }

  getLast20(): Observable<DataListModel<Newsletter>> {

    const params = new HttpParams()
      .set('page', 1)
      .set('pageSize', 20)
      ;

    return this.http.get(this.apiPath, {params}) as Observable<DataListModel<Newsletter>>;
  }


  prepareMailing(nlid: number) {
    return this.http.post(this.apiPath+'prepare', {id: nlid}) as Observable<any>;
  }
}
